export const meritBadgeCounselorsModuleName = 'meritBadgeCounselors';

export const mbcManageModuleName = 'mbcManage';
export const mbcManageModuleNamespace = `${meritBadgeCounselorsModuleName}/${mbcManageModuleName}`;

export const mbcAssignModuleName = 'mbcAssign';
export const mbcAssignModuleNamespace = `${meritBadgeCounselorsModuleName}/${mbcAssignModuleName}`;
